import type { FpMessage } from "../../../../../schemas/codegen";
import { MessageBubble } from "./MessageBubble";
import { MessageParts } from "./MessageParts";

interface MessageProps {
  message: FpMessage;
  combinedContent: string;
  expandedToolCalls: Set<string>;
  onToggleToolCallExpansion: (partId: string) => void;
}

export function Message({
  message,
  combinedContent,
  expandedToolCalls,
  onToggleToolCallExpansion,
}: MessageProps) {
  return (
    <div key={message.id} className="space-y-1">
      <MessageBubble message={message} combinedContent={combinedContent} />
      <MessageParts
        message={message}
        expandedToolCalls={expandedToolCalls}
        onToggleToolCallExpansion={onToggleToolCallExpansion}
      />
    </div>
  );
}
